import { useEffect, useState } from 'react';

// Initialize the Google search object
const useGoogleSearch = () => {
    const [googleSearch, setGoogleSearch] = useState<any>(null);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://cse.google.com/cse.js?cx=32547d276691549f7';
        script.async = true;

        if (!(window as any).google) {
            document.body.appendChild(script);
        }

        const interval = setInterval(() => {
            if ((window as any).google) {
                setGoogleSearch((window as any).google);
            }
        }, 100);
        
        return () => clearInterval(interval);
    }, []);

    const fetchQuery = (element: string, query: string) => {
        const cseElement = googleSearch.search.cse.element.getElement(element);
        return cseElement.execute(query);
    };

    return { googleSearch, fetchQuery };
};

export default useGoogleSearch;